var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('div',{attrs:{"id":"title"}},[_vm._v("Download")]),_c('button',{on:{"click":_vm.download}},[_c('span',{staticClass:"version"},[_vm._v("1.3.0b")]),_c('br'),_c('span',{staticClass:"level"},[_vm._v("Pillar")])])])}
var staticRenderFns = []

export { render, staticRenderFns }